export default "__VITE_ASSET__Dtj2KSwO__"